/* ============================================================
   [CLAUDE] Product page FAQ section | v3 2026-08-05
   Trello: https://trello.com/c/bTJ16tDY (card #245, NEW THEME)
   Adds an FAQ tab to every product page, filled from /pages/faq
   (single source of truth - editing the FAQ page updates all
   products).
   Theme tab architecture (tabs-element.product-tabs):
   - DESKTOP: .tabs__slider holds .tabs__btn buttons
   - MOBILE:  each tab is div[data-js-tabs-tab] inside .tabs__body
     with its own span[data-js-tabs-btn-mobile] accordion header
   FAQ is added as: desktop button in .tabs__slider + a full
   data-js-tabs-tab block (mobile header + .tabs__content pane)
   in .tabs__body. Own click handlers - independent of theme JS.
   Safety: read-only fetch; on any failure the tab simply does
   not appear. All in try/catch.
   ============================================================ */
(function () {
  'use strict';
  try {
    if (!/\/products\//.test(window.location.pathname)) return;

    var build = function (faqHtml) {
      try {
        if (document.querySelector('.claude-faq-wrap')) return;
        var body = document.querySelector('.tabs__body');
        var slider = document.querySelector('.tabs__slider');
        if (!body || !slider) return;

        /* --- tab block (mobile header + content pane) --- */
        var wrap = document.createElement('div');
        wrap.className = 'claude-faq-wrap';
        wrap.setAttribute('data-js-tabs-tab', '');
        var mspan = document.createElement('span');
        mspan.setAttribute('data-js-tabs-btn-mobile', '');
        mspan.textContent = 'FAQ ';
        var exIcon = body.querySelector('span[data-js-tabs-btn-mobile] i');
        if (exIcon) mspan.appendChild(exIcon.cloneNode(true));
        var pane = document.createElement('div');
        pane.className = 'tabs__content rte claude-faq-pane';
        pane.style.display = 'none';
        pane.innerHTML = faqHtml;
        wrap.appendChild(mspan);
        wrap.appendChild(pane);
        body.appendChild(wrap);

        /* mobile accordion toggle */
        mspan.style.cursor = 'pointer';
        mspan.addEventListener('click', function () {
          try {
            var cs = window.getComputedStyle(pane).display;
            pane.style.display = (cs === 'none') ? 'block' : 'none';
          } catch (e) {}
        });

        /* --- desktop tab button --- */
        var btnHtml = '<div class="tabs__btn claude-faq-tab" data-js-tabs-btn data-tab="claude-faq">FAQ</div>';
        var added = false;
        try {
          if (slider.slick && typeof slider.slick.slickAdd === 'function') {
            slider.slick.slickAdd(btnHtml);
            added = true;
          }
        } catch (e) {}
        if (!added) {
          var tmp = document.createElement('div');
          tmp.innerHTML = btnHtml;
          slider.appendChild(tmp.firstChild);
        }
        var btn = document.querySelector('.claude-faq-tab');
        if (btn) {
          btn.style.cursor = 'pointer';
          btn.addEventListener('click', function () {
            try {
              var btns = document.querySelectorAll('.tabs__btn');
              for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
              btn.classList.add('active');
              var ps = document.querySelectorAll('.tabs__content');
              for (var j = 0; j < ps.length; j++) ps[j].style.display = 'none';
              pane.style.display = 'block';
            } catch (e) {}
          });
        }
      } catch (e) { /* never break the page */ }
    };

    var init = function () {
      if (!document.querySelector('.tabs__body') || !document.querySelector('.tabs__slider')) return false;
      fetch('/pages/faq', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          try {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var head = null;
            var hs = doc.querySelectorAll('h1,h2,h3');
            for (var i = 0; i < hs.length; i++) {
              if (/faq|frequently asked/i.test(hs[i].textContent)) { head = hs[i]; break; }
            }
            var container = null;
            if (head) container = head.closest('.rte') || head.parentElement;
            if (!container) container = doc.querySelector('.rte');
            if (!container || container.textContent.replace(/\s+/g, ' ').trim().length < 200) return;
            var clone = container.cloneNode(true);
            var scripts = clone.querySelectorAll('script,style,iframe');
            for (var j = 0; j < scripts.length; j++) scripts[j].parentNode.removeChild(scripts[j]);
            build(clone.innerHTML);
          } catch (e) { /* never break the page */ }
        })
        .catch(function () {});
      return true;
    };

    var tries = 0;
    var t = window.setInterval(function () {
      tries += 1;
      try {
        if (init() || tries > 200) window.clearInterval(t);
      } catch (e) { window.clearInterval(t); }
    }, 300);
  } catch (e) { /* never break the page */ }
})();
